import StyledIcon from "../StyledIcon";

const WaMinus = props => {
    return <StyledIcon width="25" height="3" viewBox="0 0 25 3" fill="none" {...props}>
        <path d="M24.3086 1.43848H0.308594" strokeWidth="2" strokeLinejoin="round" />
    </StyledIcon>
}

export default WaMinus;